<template>
<div>

<TopBar></TopBar>

<div class="">
    <div :class="col" >
        <div class=" border-dark">
          <div id="app" style="height:85vh; background-color: white">     
               <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true" :controls="{zoom:false}" @click="clickOnPollygon"  ref="myMap" >
                   <div class="" style="position: absolute; top: 0.5em; left: 0em; z-index:2">
                    <div class=" d-flex  " style="position: relative;" >
                        <b-button size="sm" class="lg-screen h-full" @click="show_settings=!show_settings" variant="danger" style="z-index:1001;border-radius: 0px 10px 10px 0px!important;height:202px">
                            <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
                        </b-button>
                        <transition name="slide-fade">
                            <div class="w-100" v-if="show_settings">
                            <div style="position: relative;left:-10px;">
                                <div class="panel-heading" style="background-color: rgba(0, 56, 112,0.9);padding-left:20px"> Map Options </div>
                                <div class="" style="">
                                    <div class="container" style="font-size: 11px;padding-left:24px"  >
                                        <div class="row">
                                            <div  class="col">
                                        <b-card no-body class="chard-checkbox  " border-variant="secondary">
                                        
                                            <div class="boxes">
                                                    <input type="checkbox" name="radio" id="box-1" v-model="BurnedAreas" @change="AreasB" :disabled=" modis"/>
                                                    <label for="box-1" style="">Burned Areas</label>
                                                </div>
                                                <div class="boxes">
                                                    <input type="checkbox" name="radio" id="box-2" v-model="ActiveFires" @change="ActiveF" :disabled=" modis"/>
                                                    <label for="box-2">Active Fires</label>
                                            </div>
                                        
                                        </b-card>
                                            </div>
                                        <div class="col">
                                        <b-card no-body  class="chard-checkbox  "  border-variant="secondary" >
                                            <div class="boxes">
                                                    <input type="checkbox" name="radio" id="box-Noaa" v-model="Noaa" @change="NOAA_20" @click="closePopup"  />
                                                    <label for="box-Noaa" style="">NOAA_20</label>
                                            </div>
                                            <div class="boxes">
                                                <input type="checkbox" name="radio" id="box-modis" v-model="modis" @change="modisFunc" @click="closePopup"  />
                                                <label for="box-modis" >MODIS</label>
                                            </div>
                                            <div class="boxes">
                                                <input type="checkbox" name="radio" id="box-Sentinel_2" v-model="Sentinel"  @change="Sentinel_2" @click="closePopup"/>
                                                <label for="box-Sentinel_2">SENTINEL_2</label>
                                            </div>
                                        </b-card>
                                        </div>
                                        <div  class="col">
                                        <b-card no-body border-variant="secondary"  class="chard-checkbox  p-1" > 
                                            <b-button class="m-1"  size="sm" variant="warning" :pressed.sync="Last1Day" @click="Day1" style="" :disabled="!((Noaa  && (BurnedAreas || ActiveFires))|| modis)">Last 1 Day</b-button>
                                            <b-button class="m-1"  size="sm" variant="warning" :pressed.sync="Last7Day" @click="Day7" style="" :disabled="!((Noaa&& (BurnedAreas || ActiveFires))|| modis)">Last 7 Days</b-button>
                                            <b-button class="m-1"  size="sm" variant="warning" :pressed.sync="LastMonth" @click="Month" style="" :disabled="!((Noaa && (BurnedAreas || ActiveFires))|| modis)">Last Month</b-button>
                                        </b-card>
                                        </div>
                                        </div>
                                    </div>
                                        <div  class="rounded chard-checkbox">
                                            <div class="py-2  d-flex justify-content-center text-dark">   
                                                    <v-date-picker v-model="range.start" :masks="masks">
                                                    <template v-slot="{ inputValue, inputEvents }">
                                                        <div class="d-flex">
                                                            <b-icon  class="align-self-center " icon="calendar-date" scale="1" style="color:#e7b724; width: 27px; height: 27px;" ></b-icon>
                                                            <div class="px-1" >
                                                            <input
                                                                class="bg-white border px-2 py-1 rounded" style="width:110px"
                                                                :value="inputValue"
                                                                v-on="inputEvents"
                                                            />
                                                            </div>
                                                            </div>
                                                    </template>
                                                    </v-date-picker>
                                                    <b-icon  class="align-self-center " icon="dash" scale="1" style="color:#e7b724; width: 17px; height: 17px;" ></b-icon>
                                        
                                                    <v-date-picker v-model="range.end" :masks="masks">
                                                    <template v-slot="{ inputValue, inputEvents }">
                                                        <div class="d-flex">
                                                            <div class="px-1" >
                                                            <input
                                                                class="bg-white border px-2 py-1 rounded" style="width:110px"
                                                                :value="inputValue"
                                                                v-on="inputEvents"
                                                            />
                                                            </div>
                                                            </div>
                                                    </template>
                                                    </v-date-picker>   
                                                
                                                    <b-button size="sm" class="rounded" @click="apply" variant="warning" style="border-radius: 0px" :disabled="!((Noaa && (BurnedAreas || ActiveFires))|| modis)">Apply</b-button>
                                                    
                                                
                                                            
                                            </div>
                                        </div> 
                                    
                                </div>
            
                            </div>
                            </div>
                        </transition>
                    </div>

                    
                     

                   

                     <div v-if="Sentinel" style="position: absolute; top: 0.5rem; left: 25rem; z-index:2; width:50%">
                        <div class="panel-heading" style="background-color: rgba(0, 56, 112,0.9);"> Sentinel_2 Layer </div>
                        <b-card no-body class="chard-checkbox  p-3" border-variant="secondary">
                            <vue-slider v-model="valueSlider"></vue-slider>
                            <div v-if="sentinel_years_array">
                            <b-form-select  v-model="selectedSentinelYear" @change="ChangeSentinelYear" >
                                        <!-- This slot appears above the options from 'options' prop -->
                                        <template #first>
                                        <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                                        </template>

                                        <!-- These options will appear after the ones from 'options' prop -->
                                        <b-form-select-option v-for="(year,index) in sentinel_years_array" :key="index+'years'" :value="year.year">{{year.year}}</b-form-select-option>
                                        
                            </b-form-select>
                            </div>
                            </b-card>
                        
                    </div>
                   </div>
                   
                   <div class="" style="position: absolute; top: 13.1em; left: 0em; z-index:1">
                       <div v-if="BurnedAreas " >
                            
                        <div class=" d-flex mt-1">
                        <b-button size="sm" class=" lg-screen" @click="show_statistics=!show_statistics" variant="success" style="z-index:1001;border-radius: 0px 10px 10px 0px!important;height:95px">
                            <b-icon icon="bar-chart-fill" aria-hidden="true"></b-icon>
                            
                        </b-button>
                         <transition name="slide-fade">
                            <div class="width-div" v-if="show_statistics">
                                <div style="position: relative;left:-10px;">
                            <div  class="panel-heading" style="background-color: rgba(0, 56, 112,0.9);padding-left:20px"> Seasonal Trends / Statistics </div>
                            <div class=" chard-checkbox" style="border-radius: 0px 0px 4px 4px;">
                                <div class="p-3">
                                    
                                <b-form-select  v-model="selectedCountry" @change="ChangeCountry" >
                                        <!-- This slot appears above the options from 'options' prop -->
                                        <template #first>
                                        <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                                        </template>

                                        <!-- These options will appear after the ones from 'options' prop -->
                                        <b-form-select-option value="DZ">Algeria</b-form-select-option>
                                        <b-form-select-option value="AM">Armenia</b-form-select-option>
                                        <b-form-select-option value="AT">Austria</b-form-select-option>
                                        <b-form-select-option value="AZ">Azerbaijan</b-form-select-option>
                                        <b-form-select-option value="BE">Belgium</b-form-select-option>
                                        <b-form-select-option value="BA">Bosnia and Herzegovina</b-form-select-option>
                                        <b-form-select-option value="BG">Bulgaria</b-form-select-option>
                                        <b-form-select-option value="HR">Croatia</b-form-select-option>
                                        <b-form-select-option value="CZ">Czechia</b-form-select-option>
                                        <b-form-select-option value="EG">Egypt</b-form-select-option>
                                        <b-form-select-option value="FR">France</b-form-select-option>
                                        <b-form-select-option value="DE">Germany</b-form-select-option>
                                        <b-form-select-option value="EL">Greece</b-form-select-option>
                                        <b-form-select-option value="HU">Hungary</b-form-select-option>
                                        <b-form-select-option value="IR">Iran</b-form-select-option>
                                        <b-form-select-option value="IQ">Iraq</b-form-select-option>
                                        <b-form-select-option value="IL">Israel</b-form-select-option>
                                        <b-form-select-option value="IT">Italy</b-form-select-option>
                                        <b-form-select-option value="JO">Jordan</b-form-select-option>
                                        <b-form-select-option value="KW">Kuwait</b-form-select-option>
                                        <b-form-select-option value="LB">Lebanon</b-form-select-option>
                                        <b-form-select-option value="LY">Libya</b-form-select-option>
                                        <b-form-select-option value="MT">Malta</b-form-select-option>
                                        <b-form-select-option value="MD">Moldova</b-form-select-option> 
                                        <b-form-select-option value="MC">Monaco</b-form-select-option>
                                        <b-form-select-option value="ME">Montenegro</b-form-select-option>
                                        <b-form-select-option value="MA">Morocco</b-form-select-option>
                                        <b-form-select-option value="MK">North Macedonia</b-form-select-option>
                                        <b-form-select-option value="PT">Portugal</b-form-select-option>
                                        <b-form-select-option value="RO">Romania</b-form-select-option>
                                        <b-form-select-option value="RS">Serbia</b-form-select-option>
                                        <b-form-select-option value="SK">Slovakia</b-form-select-option>
                                        <b-form-select-option value="SI">Slovenia</b-form-select-option> 
                                        <b-form-select-option value="ES">Spain</b-form-select-option> 
                                        <b-form-select-option value="CH">Switzerland</b-form-select-option>
                                        <b-form-select-option value="SY">Syria</b-form-select-option>
                                        <b-form-select-option value="TN">Tunisia</b-form-select-option>
                                        <b-form-select-option value="TR">Turkey</b-form-select-option> 
                                        <b-form-select-option value="UA">Ukraine</b-form-select-option>
                                        <b-form-select-option value="VA">Vatican City</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                                </div>
                            </div>
                         </transition>
                        </div>
                       </div>
                   </div>
                   <div class="" style="position: absolute; top: 19.3em; left: 0em; z-index:1;">
                       <div v-if="BurnedAreas " >
                            
                        <div class=" d-flex mt-1">
                        <b-button size="sm" class=" lg-screen" @click="show_land=!show_land" variant="primary" style="z-index:1001;border-radius: 0px 10px 10px 0px!important;height:47px">
                            <i class="fa-solid fa-layer-group"></i>
                        </b-button>
                        <transition name="slide-fade">
                            <div class="width-div" v-if="show_land">
                                <div style="position: relative;left:-10px;">
                            <div class=" chard-checkbox rounded p-2 text-center" >
                                <b-button  class="w-75" size="sm" variant="warning" :pressed.sync="CorineButton" @click="Corine" style="">CORINE Land Cover</b-button>
                                
                            </div>
                                </div>
                            </div>
                        </transition>
                        </div>
                            
                            
                     </div>
                
                       
                   </div>
                   <!--<div class="" style="position: absolute; top: 22.4em; left: 0em; z-index:1;">
                     <div class=" d-flex align-items-center mt-1">
                        <b-button size="sm" class="py-3 lg-screen" @click="show_risk=!show_risk" variant="secondary" style="z-index:1001;border-radius: 0px 10px 10px 0px!important;background-color: #7c0059;border-color: #7c0059;">
                            <i class="fa-brands fa-gripfire" style="font-size:20px"></i>
                        </b-button>
                        <transition name="slide-fade">
                            <div class="width-div" v-if="show_risk">
                                <div style="position: relative;left:-10px;">
                                <div class=" chard-checkbox rounded p-2 d-flex items-center justify-content-center" >
                                            <div class="px-2 d-flex  items-center">
                                            <b-button  class="w-100" size="sm" variant="warning" :pressed.sync="RiskButton" @click="FireRisk" style="">
                                                
                                                Fire Risk</b-button>
                                            </div>
                                            <v-date-picker class="inline-block h-full" v-model="date" @dayclick="FireRiskCalendar">
                                                <template v-slot="{ inputValue, togglePopover }">
                                                <div class="d-flex items-center">
                                                    <b-button 
                                                    style="background:#003870"
                                                    @click="togglePopover()"
                                                    ><b-icon icon="calendar2-event-fill" aria-hidden="true"></b-icon>
                                                    </b-button>
                                                    <input
                                                    :value="inputValue"
                                                    @click="togglePopover()"
                                                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded"
                                                    readonly
                                                    />
                                                </div>
                                                </template>
                                            </v-date-picker>
                                </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                   </div>-->
                   <div  v-if="selectedCountry && BurnedAreas" class="col-md-12 justify-content-between row" style="position: absolute; bottom: 3.5em; left: 0.9em; z-index:1">
                    
                        <div class="col-lg-4">
                            <button @click="close()" type="button" class="position-absolute btn btn-dark btn-sm " style="font-size: 20px; float: right; padding: 0px 9px; z-index:3; background-color: #003870!important; ">
                            &times;
                            </button>
                            <vue-highcharts  :options="optionsCountry" ref="lineChartsCountry" style="height: 30vh;"></vue-highcharts>
                        </div>
                    <div v-if="selectedCountry == 'EL'  " class="col-lg-4 ">

                                <div  >
                                    <div class=" p-2 position-absolute" style="z-index:3">
                                        <b-form-select  v-model="selectedYear" class="" @change="ChangeYear">
                                                       
                                            <template #first>
                                            <b-form-select-option :value="null" disabled>-- Select year --</b-form-select-option>
                                            </template>

                                                        
                                            <b-form-select-option v-for="(i,index) in years" :key="i" :value="index">{{i}}</b-form-select-option>
                                            </b-form-select>
                                    </div>
                                </div>
                            <div >
                                <vue-highcharts  :options="optionsCountryGR" ref="lineChartsCountryGR" style="height: 30vh;">
                                </vue-highcharts>

                            </div>
                            <div style="position: absolute; top: 1em; right: 1.5em; z-index:1">
                            <b-spinner v-if="selectedCountry == 'EL' && spinnerLoading" label="Loading"></b-spinner>
                            </div>
                    </div>
                    
                    
                    </div>
                    <vl-view :zoom.sync="view.zoom" :center.sync="view.center" :rotation.sync="rotation"></vl-view>

                    <vl-overlay v-if="clickCoord" :position="coordinate" class="py-4">
                        <span class="popuptext" v-if="modis">
                            <h6 class="text-white" style="font-size:17px;">Informational Data:</h6>
                            <p>Sensor: <span class="text-primary">{{ sensorValue }}</span> </p>
                            <p>First Detected: <br> <span class="text-primary"> {{ firstDetected }}</span></p>
                            <p>Last Detected: <br> <span class="text-primary"> {{ lastDetected }}</span></p>
                            <p>Burned Area (HA): <span class="text-primary">{{ burndeArea }}</span></p>
                            <b-button variant="danger" @click="closePopup">close</b-button>
                        </span>
                        <span class="popuptext" v-if="Noaa">
                            <h6 class="text-white" style="font-size:17px;">Informational Data:</h6>
                            <p>Sensor: <span class="text-primary">{{ sensorValue }}</span> </p>
                            <p>First Detected: <br> <span class="text-primary"> {{ firstDetected }}</span></p>
                            <p>Last Detected: <br> <span class="text-primary"> {{ lastDetected }}</span></p>
                            <p>Confidence (min->0,max->1): <span class="text-primary">{{ confidenceValue }}</span></p>
                            <p>Reliability (min->0,max->1): <span class="text-primary">{{ reliabilityValue }}</span></p>
                            <p>Burned Area (HA): <span class="text-primary">{{ burndeArea }}</span></p>
                            <p>Photointerpretation: <span class="text-primary">{{ photointerpretation }}</span></p>
                            <b-button variant="danger" @click="closePopup">close</b-button>
                        </span>
                         
                    </vl-overlay>
                    
                    <vl-layer-tile v-if="true" id="wmts">
                    <vl-source-xyz :attributions="attribution" :url.sync="url" :layer-name="layerName"  :matrix-set="matrixSet" :style-name="styleName"
                                    ></vl-source-xyz>
                    </vl-layer-tile>
                     <!--<div v-if="fire_risk_polygon">
                    <vl-layer-vector>
                        <vl-source-vector>
                    <vl-feature v-for="(features,index) in fire_risk_polygon" :key="index">
                        
                        <vl-geom-multi-polygon :id=' ""+index+"" ' :index='index'  :coordinates="features.geometry.coordinates" ></vl-geom-multi-polygon>
                       
                        
                        
                       
                    </vl-feature>
                        </vl-source-vector>
                    </vl-layer-vector>
                    </div>-->
                        <div v-if="Sentinel">
                    <!--<vl-feature v-for="(polygon,index) in polygon.latlngs" :key="index">
                        <vl-geom-multi-polygon :coordinates="[[[[-98.844959,19.691586],[-98.842749,19.690980],[-98.842170,19.693122],[-98.844358,19.693667],[-98.844959,19.691586]]],[[[-98.847770,19.684212],[-98.849079,19.680596],[-98.845453,19.679585],[-98.844466,19.683384],[-98.847770,19.684212]]]]"></vl-geom-multi-polygon>
                        <vl-geom-multi-polygon :id=' ""+index+"" ' :index='index'  :coordinates="polygon" ></vl-geom-multi-polygon>
                       
                        <vl-style-box>
                            <vl-style-fill :color="ColorFunction(index,'polygon_fill')"></vl-style-fill>
                            <vl-style-stroke :color="ColorFunction(index,'polygon')" ></vl-style-stroke>
                        </vl-style-box>
                       
                    </vl-feature>-->
                   

                    <vl-feature v-for="(marker,index) in markers" :key="index+1">
                        <vl-geom-point :coordinates="marker"></vl-geom-point>
                        <vl-style-box>
                            <vl-style-icon :src="ColorFunction()"  :scale='0.4'></vl-style-icon>
                           
                        </vl-style-box>
                    </vl-feature>
                    </div>  
                    <div v-if="tst || load" class="loader"></div>
                    
                    <vl-layer-image v-if="Sentinel" id="sentinel" :opacity="valueSlider/100" >
                        
                    <vl-source-image-wms  :url.sync="imgUrl" :layers.sync='layerSentinel' :params='paramsSentinel' :cross-origin='crossOrigin' :server-type='serverType' ref="SentinelsourceWms"
                                        :attributions="attribution" >
                    </vl-source-image-wms>
                    </vl-layer-image>
                    <vl-layer-image v-if="(Noaa && (BurnedAreas || ActiveFires))||modis" id="xkcd">
                        <!--v-if="Noaa"-->
                    <vl-source-image-wms v-if="layer" :url.sync="imgUrl" :layers.sync='layer' :params='params' :cross-origin='crossOrigin' :server-type='serverType' ref="sourceWms"
                                        :attributions="attribution" >
                    </vl-source-image-wms>
                    </vl-layer-image>
                    <vl-layer-image id="Corine">
                    <vl-source-image-wms v-if="CorineButton" :url.sync="imgUrl" :layers.sync='layerCorine' :params='paramsCorine' :cross-origin='crossOrigin' :server-type='serverType'
                                        :attributions="attribution" ></vl-source-image-wms>
                    </vl-layer-image>
                 
                </vl-map>
          </div>
        </div>
        <div v-if="BurnedAreas || Sentinel || modis" class="rounded" style="display: block; background-color: #e9e9e9; text-align: center; padding: 5px 15px;" id="legend-burned"> <strong>Fires occurred in:&nbsp;&nbsp;</strong> 
        <img src="../../public/markers/marker-icon-2x-red.png" width="18">&nbsp;the last 2 days&nbsp;&nbsp; 
        <img src="../../public/markers/marker-icon-2x-orange.png" width="18">&nbsp;3 to 6 days before today &nbsp;&nbsp; 
        <img src="../../public/markers/marker-icon-2x-yellow.png" width="18">&nbsp;7 to 14 days before today &nbsp;&nbsp;
        <img src="../../public/markers/marker-icon-2x-blue.png" width="18">&nbsp;&gt;15 days before today &nbsp;&nbsp;  
        </div>

        <div v-if="ActiveFires" class="rounded" style="display: block; background-color: #e9e9e9; text-align: center; padding: 5px 15px;" id="legend-burned"> <strong>Fires occurred in:&nbsp;&nbsp;</strong> 
        {{ ActiveFires }}
        <img src="../../public/markers/circle-icon-2x-red.png" width="20">&nbsp;the last 2 days&nbsp;&nbsp; 
        <img src="../../public/markers/circle-icon-2x-orange.png" width="20">&nbsp;3 to 6 days before today &nbsp;&nbsp; 
        <img src="../../public/markers/circle-icon-2x-yellow.png" width="20">&nbsp;7 to 14 days before today &nbsp;&nbsp;
        <img src="../../public/markers/circle-icon-2x-blue.png" width="20">&nbsp;&gt;15 days before today &nbsp;&nbsp;  
        </div>
    
        
    </div>
    <!--<div v-if="BurnedAreas && selectedCountry" class="col-md-9 pt-0 px-2 py-2" >-->
   
</div>

<div v-if="alert">
<b-alert
      v-model="showBottom"
      class="position-fixed fixed-bottom m-0 rounded-0 text-center"
      style="z-index: 2000;"
      variant="primary"
      dismissible
      v-if="alert.show"
    >
      <!--exclamation-triangle-fill-->
      <b-icon icon="exclamation-triangle-fill" scale="1.5"></b-icon>
      <br />
      <div v-html="alert.html_text"></div>
</b-alert>
</div>
</div>


</template>

<script>

import axios from 'axios'
import TopBar from './TopBar.vue'
//import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { DatePicker } from 'v-calendar';
import VueHighcharts from 'vue2-highcharts'
//import Select from 'ol/interaction/Select';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    components:{
        TopBar,
        'v-date-picker':DatePicker,
        VueHighcharts,
        VueSlider
       
    },

    data(){
        return{
        selectedSentinelYear:null,
        sentinel_years_array:null,
        modis:false,
        fire_risk_polygon:null,
        show_settings:true,
        show_statistics:true,
        show_land:true,
        show_risk:true,
        date:new Date(),
        imgUrlRisk:'https://185.4.134.30:8080/geoserver/ffis/wms',
        layerRisk:"ffis:20220504_cells",
        paramsRisk:{ 'LAYERS': 'ffis:20220504_cells' },
        alert:null,
        showBottom: true,
        valueSlider: 100,
        markers:[],
        sentinel_data:null,
        polygon: {
          latlngs: null,
        },
        CorineButton:false,
        RiskButton:false,
        chartsCorine:[],
        years:[],
        col:'col-md-12',
        masks: {
            input: 'YYYY/MM/DD',
        },
        valuecalendar:new Date(),
        i:0,
        clickCoord: false,
        coordinate:[],
        firstDetected:"",
        sensorValue:"",
        lastDetected:"",
        confidenceValue:"",
        reliabilityValue:"",
        burndeArea:"",
        photointerpretation:"",
        range: {
            start:new Date(),
            end:new Date()
        },
        view:{
        center: [2618218, 4579844],
        zoom: 6,
        },
        rotation: 0,
        url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        //url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        layerName: '0',
        attribution: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +'rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
        //imgUrl: 'http://geosrv.space.noa.gr:8080/geoserver/msrfires/wms',
        //imgUrl: 'https://geosrv.space.noa.gr/geoserver/msrfires/wms',
        imgUrl: 'https://mapserver.beyond-eocenter.eu/geoserver/msrfires/wms',
        serverType: 'geoserver',
        crossOrigin: 'anonymous',
        params: { 'LAYERS': 'D4_view_max_date_FFIS' },
        paramsCorine:{},
        paramsSentinel:{},
        matrixSet: 'EPSG:4326',
        styleName: 'default',
        layer: 'D4_view_max_date_FFIS',
        layerCorine: '',
        layerSentinel:'',
        layerCorineShow:false,
        selected:['ardhistorical'],
        selectedCountry:null,
        selectedYear:null,
        Sentinel:false,
        Noaa:true,
        BurnedAreas:true,
        ActiveFires:false,
        Last1Day:true,
        Last7Day:false,
        LastMonth:false,
        tst:false,
        load:false,
        value:'',
        spinnerLoading:false,
        nameOfCorineArea:[],
        optionsCountry:{
            chart: {type: 'column',backgroundColor: 'rgba(135, 144, 152,0.9)',
                    
            }, 
            title: {
                text: 'Seasonal Trends / Statistics',
                style: {
                    color: '#fff',
                    
                }
            },
            legend: {
                itemStyle: {
                    font: '13pt Trebuchet MS',
                    color: 'white'
                },
                itemHoverStyle:{
                    color: 'white'
                }
            },
             xAxis: {
                gridLineColor: '#707073',
                labels: {
                    style: {
                        color: '#E0E0E3'
                    }
                }
            },
            yAxis: { min: 0,title: { text: 'Ha (total)', style: {color: 'white',font: '13pt Trebuchet MS',}},gridLineColor: 'white',labels: {style: { color: '#E0E0E3'}
        }, },
            credits: { enabled: false},
            tooltip: {headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f} HA</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                series: {
                    borderColor: '#303030'
                },
                column: { borderWidth: 1.5}},
            series: [],
        },
        optionsCountryGR:{
            chart: {type: 'pie',backgroundColor: 'rgba(135, 144, 152,0.9)'},
            colors: ['red', 'orange', 'green', 'blue', 'purple', 'brown'],
            title: {text: 'Burned Areas per Corine Usage', 
                style: {
                        color: '#fff',
                        
                    }},
            credits: { enabled: false},
            plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.y:.1f} '
                },
                showInLegend: false,
        }
    },
            series: [{
                type: 'pie',
            }]
        }
        }
    },
    created(){
        console.log(window.innerWidth)
    if(window.innerWidth<768){
        this.show_statistics=false
        this.show_land=false
        this.show_risk=false
    }
    // add in items only the data of .json file
    this.Day1()
    var v=this
    axios.get('json/alert.json').then((response)=>{
        console.log(response)
        v.alert=response.data
    })
   
    /*
    axios.get('http://localhost/ffis-backend/loadMap.php',{params:{
        geotable:'tempdata_dis',
        geomfield:'st_union',
        srid:3857,
        parameters:"risk_date='2022-06-07'"
    }}).then((response)=>{
        console.log(response.data)
        v.fire_risk_polygon=response.data.features
        console.log(v.fire_risk_polygon)
    })*/
    },
    methods:{
    ChangeSentinelYear(){
        console.log(this.selectedSentinelYear)
        this.Sentinel_2()
    },
    ImageWMS(layers,firstdate,enddate){
        if(this.Noaa || this.modis){
            this.layer=null
            this.params=null
            setTimeout(() => {
                this.tst=true
                var tt = "t1:" + "'" + firstdate + "';t2:" + "'" + enddate + "'";
                this.params={ 'LAYERS': layers, 'viewparams': tt }
                //console.log(this.params)
                this.layer=layers
            }, 500)
           
        }
       
    },
    ColorFunction(){
        return 'markers/icon-map.png'  
       
    },
    modisFunc(){
        if(this.modis){
            this.Noaa=false
            //this.BurnedAreas=true
             this.AreasBModis()
             
        }else{
            this.Last1Day=false
        }
    },
    NOAA_20(){
        
        //this.Sentinel=false
        
        //this.polygon.latlngs=null
        if(this.Noaa){
            this.BurnedAreas=true
            this.modis=false
            this.AreasB()
        }else{
            this.Last1Day=false
        }
       
        
    },
    async Sentinel_2(){
       
        
        //this.CorineButton=false
        //this.Noaa=false
        //this.ActiveFires=false
        //this.BurnedAreas=true
        //this.layer= null
        //this.params={ 'LAYERS': 'msrfires:Sentinel_view'}
        //this.layer='msrfires:Sentinel_view'
        //this.params={ 'LAYERS': 'D4_view_max_date_FFIS'}
        //this.layer='D4_view_max_date_FFIS'
        if(this.Sentinel){
        
             
        if(!this.selectedSentinelYear){
            var sentinel_years= await axios.get('https://ffis.beyond-eocenter.eu/backend/sentinel2_years.php')
            this.sentinel_years_array=sentinel_years.data
            this.selectedSentinelYear=this.sentinel_years_array[0].year
       // console.log(sentinel_years)
        }
            //this.Sentinel_2_Data()
        var timestart= this.selectedSentinelYear+'-01-01T01:01:01'
        var timeend= (parseInt(this.selectedSentinelYear)+1)+'-01-01T01:01:01'
        console.log(timeend)
        this.paramsSentinel={ 'LAYERS': 'msrfires:SENTINEL_View_FFIS','cql_filter': `detected_timestamp > ${timestart} and detected_timestamp < ${timeend}`}
        this.layerSentinel='msrfires:SENTINEL_View_FFIS'
        this.Sentinel_2_Data()
        }

       
       //this.clickCoord=undefined
      // this.closePopup()
    },
    async Sentinel_2_Data(){
    //this.load=true
    var sentinel=await axios.get('https://ffis.beyond-eocenter.eu/backend/sentinel2.php',{params:{year:this.selectedSentinelYear}})
    //console.log(sentinel)
    this.sentinel_data=sentinel.data
    console.log(this.sentinel_data)
    
    //console.log(test)
    
    this.markers=[]
   // this.polygon.latlngs=[]
    for(var i=0; i<sentinel.data.length; i++){
        var point=JSON.parse(sentinel.data[i].st_asgeojson)
        this.markers.push(point.coordinates)
       // var polygons=JSON.parse(sentinel.data[i].geom)
       // this.polygon.latlngs.push(polygons.coordinates)
    }
    console.log(this.markers)

     //this.load=false
     //this.tst=true
    
    },
    AreasBModis(){
        
        this.Last1Day=false
        this.Last7Day=false
        this.LastMonth=false
        this.ActiveFires=false
        this.BurnedAreas=true
        this.selectedCountry=null
        this.layer= 'MODIS_View_FFIS'
        //this.layer='D4_view_max_date_FFIS'
        this.Day1()
        
        
    },
    AreasB(){
        
        this.Last1Day=false
        this.Last7Day=false
        this.LastMonth=false
        this.ActiveFires=false
        this.selectedCountry=null
        this.layer= 'D4_view_max_date_FFIS'
        //this.layer='D4_view_max_date_FFIS'
        this.Day1()
        
        
    },
    ActiveF(){
        this.Last1Day=false
        this.Last7Day=false
        this.LastMonth=false
        this.BurnedAreas=false
        //this.col=this.col='col-md-12'
        this.layer= null
        this.CorineButton=false
        
        //this.Corine()
        this.Day1()
        
    },
    Day1(){
      
        
            this.Last7Day=false
            this.LastMonth=false
            this.Last1Day=true
            
            var enddate = new Date();
            var today = new Date();
            enddate.setDate(today.getDate()+1);
            var todayday = new Date();
            todayday.setDate(today.getDate()-1);
            if(this.modis){
                
                this.ImageWMS('msrfires:MODIS_View_FFIS', todayday.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
            
            }else{
                if(this.BurnedAreas){
                    this.params={ 'LAYERS': 'D4_view_max_date_FFIS'}
                    this.layer='D4_view_max_date_FFIS'
                }
                //console.log(this.ActiveFires)
                if(this.ActiveFires){
                    console.log("ActiveFires")
                    this.ImageWMS("msrfires:D2_View_FFIS", todayday.toLocaleDateString('sv'),enddate.toLocaleDateString('sv')) 
                }
            }
            //this.closePopup()
        

    },
    Day7(){
        this.Last1Day=false
        this.LastMonth=false
       // this.Last7Day=true
        
        if(this.Last7Day){
        var dayPr7 = new Date();
        dayPr7.setDate(dayPr7.getDate() - 7);
        var enddate = new Date();
        var today = new Date();
        enddate.setDate(today.getDate() + 1);
        if(this.modis){
          
            this.ImageWMS('msrfires:MODIS_View_FFIS', dayPr7.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
         
       }else{
            if(this.BurnedAreas){
            this.ImageWMS('msrfires:D4_View_FFIS', dayPr7.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
            }
            if(this.ActiveFires){
            this.ImageWMS("msrfires:D2_View_FFIS", dayPr7.toLocaleDateString('sv'),enddate.toLocaleDateString('sv')) 
            }
       }
       
        
        }
        else{
           this.Day1()
           this.Noaa=true
        }
        //this.closePopup()
    },
    Month(){
        //this.LastMonth=true
        this.Last1Day=false
        this.Last7Day=false
        
        if(this.LastMonth){
        var enddate = new Date();
        var today = new Date();
        enddate.setDate(today.getDate() + 1);
        var dayPr30 = new Date();
        dayPr30.setDate(dayPr30.getDate() - 30);
        
        if(this.modis){
           
           
            this.ImageWMS('msrfires:MODIS_View_FFIS', dayPr30.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
          
        }
        if(this.Noaa){
            if(this.BurnedAreas){
                this.ImageWMS('msrfires:D4_View_FFIS', dayPr30.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
            }
            if(this.ActiveFires){
                this.ImageWMS("msrfires:D2_View_FFIS", dayPr30.toLocaleDateString('sv'),enddate.toLocaleDateString('sv')) 
            }
        }
       
        
        }
        else{
            this.Day1()
            this.Noaa=true
        }
        //this.closePopup()
    },
     apply(){
         //console.log(this.ActiveFires)
        this.Last1Day=false
        this.Last7Day=false
        this.LastMonth=false
        var enddate = this.range.end
        enddate.setDate(this.range.end.getDate() + 1);

        if(this.modis){
          
            this.ImageWMS("msrfires:MODIS_View_FFIS",this.range.start.toLocaleDateString('sv'),enddate.toLocaleDateString('sv')) 
           
        }else{
            if(this.BurnedAreas){
                this.ImageWMS('msrfires:D4_View_FFIS',this.range.start.toLocaleDateString('sv'),enddate.toLocaleDateString('sv'))
            }
            if(this.ActiveFires){
                this.ImageWMS("msrfires:D2_View_FFIS",this.range.start.toLocaleDateString('sv'),enddate.toLocaleDateString('sv')) 
            }
        }
       
        
        
        //console.log( this.$refs.sourceWms.getParams())
        
       // this.closePopup()
    },
   async clickOnPollygon(event){

       //console.log(event)
        this.clickCoord=false
        var map=this.$refs.myMap.$map
        var zoomlevel = map.getView().getZoom()
        this.coordinate=event.coordinate
    
    /*var selectSingleClick = new Select();
    console.log(selectSingleClick)
    map.addInteraction(selectSingleClick);
      // console.log( this.$refs.myMap.$map.getView().getZoom())
    //alert(zoomlevel);
    var features = map.getFeaturesAtPixel(event.pixel);
    //console.log(event.pixel)
    //console.log(features)
    if(features[0] && this.Sentinel){
    
    var properties = features[0].getProperties();
    //console.log(properties.geometry.values_.id)
    var index=parseInt(properties.geometry.values_.id)
    //console.log(index)
        this.sensorValue = this.sentinel_data[index].sensor;
        this.firstDetected = this.sentinel_data[index].detected_timestamp;
        this.lastDetected = '-'
        this.confidenceValue = '-'
        this.reliabilityValue = '-'
        this.burndeArea = Number.parseFloat(this.sentinel_data[index].area_ha).toFixed(2);
        if(this.sentinel_data.manual==='t'){
            this.photointerpretation = 'true';
        }else{
            this.photointerpretation = 'false';
        }
        
        this.clickCoord= true 
    }*/

    if (zoomlevel < 10) {
      map.getView().setCenter(event.coordinate);
      map.getView().setZoom(10);

    }

    //console.log('this.$refs.sourceWms')
    //if(this.Noaa){
    var viewResolution = /** @type {number} */ (map.getView().getResolution());
     if(this.$refs.sourceWms){
        
    var urlNoaa = await this.$refs.sourceWms.getFeatureInfoUrl(
      event.coordinate,viewResolution, 'EPSG:3857',
      { 'INFO_FORMAT': 'application/json' });
    
    
    if (urlNoaa) {
        console.log('urlNoaa')
        const html=await fetch(urlNoaa).then(function (response) {  return response.text(); })
        
        var burnedAreaFeatures = JSON.parse(html);
           console.log(JSON.parse(html))
       
        if(burnedAreaFeatures.crs){
            if(this.modis){
                //console.log(burnedAreaFeatures.features[0].properties)
                this.sensorValue = burnedAreaFeatures.features[0].properties.sensor;
                this.firstDetected = burnedAreaFeatures.features[0].properties.detected_timestamp;
                this.lastDetected = burnedAreaFeatures.features[0].properties.ref_timestamp;
                //this.confidenceValue = burnedAreaFeatures.features[0].properties.confidence.toFixed(2);
                //this.reliabilityValue = burnedAreaFeatures.features[0].properties.reliability.toFixed(2);
                this.burndeArea = burnedAreaFeatures.features[0].properties.area_ha.toFixed(2);
                //this.photointerpretation = burnedAreaFeatures.features[0].properties.manual;
                this.clickCoord= true  
            }else if(this.Noaa){
                this.sensorValue = burnedAreaFeatures.features[0].properties.sensor;
                this.firstDetected = burnedAreaFeatures.features[0].properties.detected_timestamp;
                this.lastDetected = burnedAreaFeatures.features[0].properties.ref_timestamp;
                this.confidenceValue = burnedAreaFeatures.features[0].properties.confidence.toFixed(2);
                this.reliabilityValue = burnedAreaFeatures.features[0].properties.reliability.toFixed(2);
                this.burndeArea = burnedAreaFeatures.features[0].properties.area_ha.toFixed(2);
                this.photointerpretation = burnedAreaFeatures.features[0].properties.manual;
                this.clickCoord= true  
            }
         
          
        }
    

    }
    }
    if(this.$refs.SentinelsourceWms){
    var urlSentinel= await this.$refs.SentinelsourceWms.getFeatureInfoUrl(
      event.coordinate,viewResolution, 'EPSG:3857',
      { 'INFO_FORMAT': 'application/json' });
    if(urlSentinel){
        const html=await fetch(urlSentinel).then(function (response) {  return response.text(); })
        
        var burnedAreaFeatures = JSON.parse(html);
           //console.log(JSON.parse(html))
       
        if(burnedAreaFeatures.crs){
            
            this.sensorValue = burnedAreaFeatures.features[0].properties.sensor;
            this.firstDetected = burnedAreaFeatures.features[0].properties.detected_timestamp;
            this.lastDetected = '-'
            this.confidenceValue = '-'
            this.reliabilityValue = '-'
            this.burndeArea = Number.parseFloat(burnedAreaFeatures.features[0].properties.area_ha).toFixed(2);
            this.photointerpretation = burnedAreaFeatures.features[0].properties.manual; 
            this.clickCoord= true 
        
        }


    }
   }
   // }
    },

    async ChangeCountry(){
        //console.log(this.selectedCountry)
       // this.col='col-md-3'
        
        //const data_all= await axios.get("http://geosrv.space.noa.gr:8080/geoserver/wms?request=GetFeatureInfo&service=WMS&version=1.1.1&layers=D4_view_country_stats&styles=&srs=EPSG%3A4326&format=image%2Fpng&bbox=6,35,18,47&width=1&height=1&query_layers=D4_view_country_stats&viewparams=cntr:'" + this.selectedCountry + "'&info_format=application/json&feature_count=50&x=1&y=1&exceptions=application/JSON")
        const data_all= await axios.get("https://mapserver.beyond-eocenter.eu/geoserver/wms?request=GetFeatureInfo&service=WMS&version=1.1.1&layers=D4_View_Country_Stats_FFIS&styles=&srs=EPSG%3A4326&format=image%2Fpng&bbox=6,35,18,47&width=1&height=1&query_layers=D4_View_Country_Stats_FFIS&viewparams=cntr:'" + this.selectedCountry + "'&info_format=application/json&feature_count=50&x=1&y=1&exceptions=application/JSON")

    
        const data=data_all.data
        var currentDate = new Date();
        var currentYearOnly = currentDate.getFullYear();
        var firstYearWithData = 2018;
        var totalYearsWithData = currentYearOnly - firstYearWithData + 1;

        //declare arrays
        var yearsXAxis = [];
        var yearsYAxis = [];
        
        //fill x axis with all years
        for (var x = 0; x < totalYearsWithData; x++) {
          yearsXAxis.push(firstYearWithData + x);
        }
       

        //check if the 2 arrays have the same number of elements
        if (data.features.length == yearsXAxis.length) {
          for (var i = 0; i < data.features.length; i++) {
            yearsYAxis.push(Math.round(data.features[i].properties.sum));
          }
        } else {
          // filling yAxis with 0 Values
          for (var y = 0; y < yearsXAxis.length; y++) {
            yearsYAxis[y] = 0;
          }
          for (var k=0; k < data.features.length; k++) {
            for (var z = 0; z < yearsXAxis.length; z++) {
              if (yearsXAxis[z] == data.features[k].properties.year){
                 yearsYAxis[z] = data.features[k].properties.sum;
              }
            }      
          }

         }
        
        var lineChartsCountry = this.$refs.lineChartsCountry
        lineChartsCountry.removeSeries()
        lineChartsCountry.getChart().xAxis[0].setCategories(yearsXAxis)
        
        lineChartsCountry.addSeries({
            name: this.selectedCountry,
            data: yearsYAxis
        })


        if (this.selectedCountry=="EL"){
            this.CorineButton=true
            this.layerCorine= 'CorineLandCover'
            
            //this.layer= 'D4_view_max_date_FFIS'
            this.chartDataCorine()
        }
    },
    async chartDataCorine(){
                console.log('here')
                this.spinnerLoading=true
                //var lineChartsCountryGR = this.$refs.lineChartsCountryGR
               // if(lineChartsCountryGR){
               // lineChartsCountryGR.removeSeries()
               // }
               // const data_all_EL= await axios.get("http://geosrv.space.noa.gr:8080/geoserver/wms?request=GetFeatureInfo&service=WMS&version=1.1.1&layers=GR_burned_LC&styles=&srs=EPSG%3A4326&format=image%2Fpng&bbox=6,35,18,47&width=1&height=1&query_layers=GR_burned_LC&info_format=application/json&feature_count=50&x=1&y=1&exceptions=application%2Fvnd.ogc.se_xml")
                //const data_all_EL= await axios.get("https://mapserver.beyond-eocenter.eu/geoserver/wms?request=GetFeatureInfo&service=WMS&version=1.1.1&layers=GR_Burned_LandCover&styles=&srs=EPSG%3A4326&format=image%2Fpng&bbox=6,35,18,47&width=1&height=1&query_layers=GR_Burned_LandCover&info_format=application/json&feature_count=50&x=1&y=1&exceptions=application%2Fvnd.ogc.se_xml")
                const data_all_EL = await axios.get("https://ffis.beyond-eocenter.eu/backend/clc_areas_by_year.php")
                //console.log('data_all_EL',data_all_EL)
                const data_EL=data_all_EL.data//.features
                //console.log("corine:",data_EL);
                //console.log(yearsXAxis)
                this.chartsCorine=[]
                this.years=[]
                for(var i=0; i<data_EL.length; i++){
                    if(data_EL[i].code>299){
                    if(!this.years.includes(data_EL[i].year)){
                        //console.log('here')
                        //this.yearNoSort.push(this.chart_data.data[i].extractYear)
                        this.years.push(data_EL[i].year)
                        this.chartsCorine.push({year: data_EL[i].year})
                    }
                    if(this.chartsCorine[this.years.indexOf(data_EL[i].year)].area) {
                        this.chartsCorine[this.years.indexOf(data_EL[i].year)].area.push(data_EL[i].area)
                        this.chartsCorine[this.years.indexOf(data_EL[i].year)].code.push(data_EL[i].code)
                        this.chartsCorine[this.years.indexOf(data_EL[i].year)].name.push(data_EL[i].name)
                        //this.chartsCorine[this.years.indexOf(data_EL[i].properties.year)].area.push({name:data_EL[i].properties.name},{y:data_EL[i].properties.area})
                        
                    }
                    else{
                       this.chartsCorine[this.years.indexOf(data_EL[i].year)].area = [data_EL[i].area]
                       this.chartsCorine[this.years.indexOf(data_EL[i].year)].code = [data_EL[i].code]
                       this.chartsCorine[this.years.indexOf(data_EL[i].year)].name = [data_EL[i].name]
                       //this.chartsCorine[this.years.indexOf(data_EL[i].properties.year)].data = [{name:data_EL[i].properties.name},{y:data_EL[i].properties.area}]
                       
                    }
                    }
                }
                console.log(this.chartsCorine)
                console.log(this.years)
                /*
                var corineUseAxis=[]; // the x axis of usages
                var corineSumAxis=[]; // the y axis of usages
                    for (var i = 0; i < data_EL.features.length; i++) {
                        corineUseAxis.push(data_EL.features[i].properties.code);
                    } //fill the array with usage codes
                    for (var j = 0; j < data_EL.features.length; j++) {
                        corineSumAxis.push(Math.round(data_EL.features[j].properties.area));
                    } //fill the array with usage sums
                        console.log(corineSumAxis);
                //var lineChartsCountryGR = this.$refs.lineChartsCountryGR
                lineChartsCountryGR.removeSeries()
                lineChartsCountryGR.getChart().xAxis[0].setCategories(corineUseAxis)
                
                lineChartsCountryGR.addSeries({
                    name: this.selectedCountry,
                    data: corineSumAxis
                })
                */
                this.selectedYear='0'
                this.CorineChart()
                this.spinnerLoading=false
    },
    ChangeYear(){
        this.CorineChart()
        
    },
    CorineChart(){
        //console.log(this.selectedYear)
        var lineChartsCountryGR = this.$refs.lineChartsCountryGR
                if(lineChartsCountryGR){
                lineChartsCountryGR.removeSeries()
            }
        lineChartsCountryGR.addSeries({
                name:'Burned Areas'
        })
       //console.log(lineChartsCountryGR.getChart())

        for(var i=0; i<this.chartsCorine[0].area.length; i++){
            if(!this.nameOfCorineArea.includes(this.chartsCorine[this.selectedYear].name[i])){
                this.nameOfCorineArea.push(this.chartsCorine[this.selectedYear].name[i])
            } 

            lineChartsCountryGR.getChart().series[0].addPoint({name:this.chartsCorine[this.selectedYear].name[i],y:parseFloat(this.chartsCorine[this.selectedYear].area[i]),color: {
                radialGradient: {
                        cx: 0.5,
                        cy: 0.5,
                        r: 0.9
                    },
                stops: [
                    [0,"#" + Math.floor(Math.random()*16777215).toString(16)],
                    //lineChartsCountryGR.getChart().options.colors[this.nameOfCorineArea.indexOf(this.chartsCorine[this.selectedYear].name[i])]],
                    [1, '#383838']
                ]
            }})
        }
    },
    FireRisk(){
        console.log('here')
    },
    FireRiskCalendar(date){
        console.log(date)
        this.layerRisk="ffis:20220504_cells"
        //this.paramsRisk={ 'LAYERS': '' }
        this.paramsRisk={ 'LAYERS': 'ffis:20220504_cells', 'viewparams': date.id }
       // console.log(this.$refs.sourceWmsFireRisk)
    },
    Corine(){
        if(this.CorineButton){
            this.paramsCorine={ 'LAYERS': 'CorineLandCover' }
            this.layerCorine= 'CorineLandCover'
            
            //this.layer= 'D4_view_max_date_FFIS'
            this.layer= null
            this.selectedCountry='EL'
            this.ChangeCountry()
        }else{
            
            //this.paramsCorine=null
            
            this.close()
        }
    },
    dateSelected(e, date, toggle) {
      //this.selected = date;
      toggle({ ref: e.target });
    },

    test(){
        //console.log(this.inputValue.start)
    },
    close(){
       
        this.selectedCountry=null
    },
    closePopup(){
        this.clickCoord = false
    }



    },

    mounted(){
    this.$refs.myMap.$on("rendercomplete", evt => {
        //console.log('here')
        this.tst=false
        //console.log('here')
      //this.mapLoading =!this.mapLoading //works fine without vector layer
      
    });
     
    },

}
</script>

<style>
.panel-heading {
    padding: 0px 8px;
    border-bottom: 1px solid transparent;

    color: #fff;
    font-family: Trebuchet MS,Helvetica,sans-serif;
    
}

 .active {
    background: #003870 !important;
    color: #ffffff !important;
  }

.popuptext {

  width: 250px;
  background-color: #484848;
  color: #fff;
  border-radius: 6px;
  padding: 8px 8px;
  position: absolute;
  z-index: 1;
  bottom: 160%;
  left: 50%;
  margin-left: -120px;
}
.popuptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -10px;
  border-width: 10px;
  border-style: solid;
  border-color: #484848 transparent transparent transparent;
}
p{
    margin-bottom: 0rem !important;   
}
.loader{
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background: url('../../public/img/load1.gif') 50% 50% no-repeat rgba(255,193,249,0.5)

}







.boxes {
  
  padding: 8px;
  

}

/*Checkboxes styles*/
input[type="checkbox"] { display: none; }

input[type="checkbox"] + label {
  
  position: relative;
  padding-left: 35px;
 
  text-transform: capitalize;
  font: 14px/20px 'Open Sans', Arial, sans-serif;
  color: rgb(255, 255, 255);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

input[type="checkbox"] + label:last-child { margin-bottom: 0; }

input[type="checkbox"] + label:before {
  content: '';
  display: block;
  width: 20px;
  height: 20px;
  border: 1px solid #ffffff;
  position: absolute;
  left: 0;
  top: 0;
  opacity: .6;
  -webkit-transition: all .12s, border-color .08s;
  transition: all .12s, border-color .08s;
}

input[type="checkbox"]:checked + label:before {
  width: 10px;
  top: -5px;
  left: 5px;
  border-radius: 0;
  opacity: 1;
  border-top-color: transparent;
  border-left-color: transparent;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.col{
    padding-right: 0px; 
    padding-left: 0px;
}
.card{
    margin-bottom: 0px;
    height:100%;
    border-radius: .0rem;
}
.chard-checkbox{
     background-color: rgba(135, 144, 152,0.8)!important;
}


.col-md-12{
    padding-right: 0px;
    padding-left: 0px;
}

.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
  opacity: 0;
}

.ol-zoom{
    display: none
}
.width-div{
    width: 390px;
}
@media only screen and (max-width: 422px) {
.width-div{
    width: 100%;
}
}


</style>
